import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '@cc-shopping/structured-content-renderer/hydration/types';
import { renderStructuredContent } from '@cc-shopping/structured-content-renderer/renderContext';
import { getAllChildrenStrings } from '@cc-shopping/structured-content-renderer/utils';
import { Fragment } from 'react';
import { LinkClient } from './Link.client';
import { isExternalLink } from './utils';
export type LinkProps = StructuredContentDocumentWithRenderer<{
  href?: string;
  target?: string;
  children: StructuredContentDocument[] | string[];
}>;
export const Link = t0 => {
  const $ = _c(13);
  const {
    props
  } = t0;
  const t1 = props.children;
  let childrenArray;
  let t2;
  let t3;
  if ($[0] !== props.children) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      childrenArray = [t1].flat();
      if (childrenArray.length === 0) {
        t3 = null;
        break bb0;
      }
      t2 = childrenArray.map(_temp);
    }
    $[0] = props.children;
    $[1] = childrenArray;
    $[2] = t2;
    $[3] = t3;
  } else {
    childrenArray = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const renderedChildren = t2;
  let t4;
  if ($[4] !== childrenArray[0] || $[5] !== props) {
    t4 = typeof childrenArray[0] === "string" ? childrenArray[0] : getAllChildrenStrings({
      props
    } as StructuredContentDocument);
    $[4] = childrenArray[0];
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const linkCopy = t4;
  const rel = props.href && isExternalLink(props.href) && props.target === "_blank" ? "noopener nofollow" : undefined;
  let t5;
  if ($[7] !== linkCopy || $[8] !== props.href || $[9] !== props.target || $[10] !== rel || $[11] !== renderedChildren) {
    t5 = <LinkClient href={props.href} target={props.target} rel={rel} linkCopy={linkCopy}>{renderedChildren}</LinkClient>;
    $[7] = linkCopy;
    $[8] = props.href;
    $[9] = props.target;
    $[10] = rel;
    $[11] = renderedChildren;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(child, idx) {
  if (typeof child === "string") {
    return child;
  }
  return <Fragment key={`sc-link-${idx}`}>{renderStructuredContent(child)}</Fragment>;
}